import { useContext } from 'react';
import { IDCREASChartsDataContext } from '../contexts/IDCREASChartsDataContext';

export const useIDCREASChartsDataContext = () => {
    return useContext(IDCREASChartsDataContext);
};